import env from '../env'

/**
 * This function receives a text, checks the existence of links
 * and returns a new text with the links replaced by an anchor tag.
 *
 * @param string text
 * @returns string
 */
export const linksToHtml = text => {
  let replacedText, replacePatternSchema, replacePatternWWW
  //URLs starting with http://, https://, or ftp://
  replacePatternSchema =
    /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
  replacedText = text.replace(replacePatternSchema, '<a href="$1" target="_blank">$1</a>')

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePatternWWW = /(^|[^\/])(www\.[\S]+(\b|$))/gim
  replacedText = replacedText.replace(
    replacePatternWWW,
    '$1<a href="http://$2" target="_blank">$2</a>'
  )
  return replacedText
}

/**
 * This function sanitizes a text removing all html tags to
 * avoid XSS attacks.
 *
 * @param string text
 * @returns
 */
export const sanitizeText = text => {
  return text.replace(/<(?:.|\n)*?>/gm, '')
}

/**
 * TODO: use datejs instead of this function
 *
 * @param string date
 * @returns string
 */
export const humanDate = date => {
  date = date.replace(/-/g, '/')
  const postDateTime = new Date(date)
  const todayDateTime = new Date()

  const postDate = [
    postDateTime.getDate(),
    postDateTime.getMonth() + 1,
    postDateTime.getFullYear(),
  ].join('/')
  const todayDate = [
    todayDateTime.getDate(),
    todayDateTime.getMonth() + 1,
    todayDateTime.getFullYear(),
  ].join('/')
  const postTime = [
    postDateTime.getHours(),
    String(postDateTime.getMinutes()).padStart(2, 0),
  ].join(':')

  if (postDate === todayDate) {
    return `hoy a las ${postTime}`
  }

  return `el ${postDate} a las ${postTime}`
}

/**
 * This function checks if a filename corresponds to a video
 *
 * @param string filename
 * @returns boolean
 */
export const isVideo = filename => {
  const VIDEO_FORMATS = ['.mp4', '.mov', '.flv', '.avi', '.mpeg-4', '.m4v', 'webm']

  return VIDEO_FORMATS.some(format => filename.toLowerCase().indexOf(format) > -1)
}

/**
 * This function gets the url of a file from storage
 *
 * @param string filename
 * @returns string
 */
export const getURL = filename => {
  return env.storage + encodeURIComponent(filename)
}

/**
 * This function gets the url of a file from transcoded storage folder
 *
 * @param string filename
 * @returns string
 */
export const getTranscodedVideoURL = filename => {
  return `${env.video_cdn}transcoded/${encodeURIComponent(filename)}`
}

export const getPosterURL = filename => {
  const name = filename.slice(0, filename.length - 4) + '-00001.png'
  return `${env.video_cdn}transcoded/${encodeURIComponent(name)}`
}

export const truncate = (text, length = 50) => {
  if (text.length > length) {
    return text.substring(0, length) + '...'
  }

  return text
}

export const isMobileScreen = () => {
  return window.innerWidth <= 768
}

export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const isIPhone = () => {
  const platform = navigator?.userAgentData?.platform || navigator?.platform || 'unknown'
  const userAgent = navigator?.userAgent || ''
  const isIpad =
    platform === 'iPad' ||
    (platform === 'MacIntel' && navigator?.maxTouchPoints > 1) ||
    /iPad/i.test(userAgent)
  return platform === 'iPhone' || /iPhone/i.test(userAgent) || isIpad
}
